/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import axios from 'axios'
import React, {Fragment, useCallback, useEffect, useState} from 'react'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import {KTSVG} from '../../../_metronic/helpers'
import {resendToSAP, synchronizeInvoice, updateInvoice} from '../../../api/modules/invoice'
import {PopoverText} from '../../../components/Popover/Popover'
import {StyledCard} from '../../../components/StyledCard'
import * as TableUI from '../../../components/Table/Table'
import {useRowTable} from '../../../hooks/useRowTable'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {invoiceSelector, resetFilter} from '../../../redux/slices/invoiceSlices'
import {fetchInvoices, headers} from '../../../services/fetcher'
import {objToParams} from '../../../utils/objToParams'
import Pagination from '../component/Pagination'
import {ButtonGroups} from './ButtonGroups'
import {RowFilter} from './RowFilter'
import dateformat from 'src/utils/dateformat'
import {setIsFetchData} from 'src/redux/slices/filterSlices'

type Props = {
  className: string
}

const InvoiceTable: React.FC<Props> = ({className}) => {
  const navigate = useNavigate()
  const {filter} = useAppSelector(invoiceSelector)
  const dispatch = useAppDispatch()
  const [lang, setLang] = useState<any>('id')
  const [loading, setLoading] = useState(false)
  const {t} = useTranslation()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 16,
    onReloadTable: () => handleReloadTable(),
  })

  const [isFailed, setIsFailed] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [invoiceData, setInvoiceData] = useState<any[]>([])
  const [roleUser, setRoleUser] = useState<any>('')
  const [filterAsc, setFilterAsc] = useState<any>('')
  const [filterCus, setFilterCus] = useState<any>('')
  const [tooltip, setTooltip] = useState('Open')
  const [showEdit, setShowEdit] = useState(false)
  const [tempDetail, setTempDetail] = useState<any>([])
  const [dueDate, setDueDate] = useState<any>('')
  const [dueDate2, setDueDate2] = useState<any>('')

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      // console.log(language)
      setLang(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const condTOP = (top: any) => {
    let trimmedTOP = ''
    if (top?.slice(1, 100) != undefined)
      trimmedTOP = 'Within ' + top?.slice(1, 100) + t(' days Due net')
    if (top == 'Z0LC') return 'Letter of Credit TOP'
    else if (top == 'Z000') return 'Payable immediately Due net'
    else if (top != 'Z0LC' && top != 'Z000') return trimmedTOP
  }

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const onFetchInvoice = useCallback(() => {
    setLoading(true)
    setIsFailed(false)

    fetchInvoices(filter)
      .then((res) => {
        setInvoiceData(res.data.data.data)
        setNumberURL(res.data.data.links)
      })
      .catch(() => setIsFailed(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filter])

  useEffect(() => {
    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }
    role()
  }, [])

  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
      setTooltip('Close')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
      setTooltip('Open')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const paginateNumber = async (url: any) => {
    if (!url) return
    setLoading(true)

    const token = localStorage.getItem('token') as string
    const credentials = localStorage.getItem('credential') as string
    const endpoint = `${url}&credentials=${credentials}&${objToParams(filter)}`
    const res = await axios.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})

    setInvoiceData(res.data.data.data)
    setLoading(false)
    setNumberURL(res.data.data.links)
  }

  const syncInvoice = async () => {
    await synchronizeInvoice({
      customer_code: localStorage.getItem('cust-code'),
      lang: lang,
      credentials: localStorage.getItem('credential'),
    })
      .then((res) => {
        swal({
          title: `${t('Invoice syncronized')}`,
          icon: 'success',
        })
      })
      .then(() => onFetchInvoice())
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
  }

  function convertDatePicker(date: any) {
    let dd = String(date.getDate()).padStart(2, '0')
    let mm = String(date.getMonth() + 1).padStart(2, '0')
    let yyyy = String(date.getFullYear())
    return yyyy + '-' + mm + '-' + dd
  }

  const handleShowEdit = (item: any) => {
    setDueDate(item.due_date)
    setDueDate2(item.due_date != null ? new Date(item.due_date + ' 00:00:00') : '')
    setTempDetail(item)
    setShowEdit(true)
  }

  const sendEditInvoice = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (accept) => {
      if (accept) {
        await updateInvoice(id, {
          due_date: dueDate,
          credentials: localStorage.getItem('credential'),
        })
          .then((res) => {
            if (!res.data.error) {
              swal({
                title: `${t('Harga Berhasil Diperbarui')}`,
                icon: 'success',
              }).then(() => {
                // getAllInvoice()
                handleReloadTable()
                setShowEdit(false)
              })
            } else
              swal({
                title: `${res.data}`,
                icon: 'error',
              })
          })
          .catch(function (error) {
            if (error.response) {
              swal({
                title: `${error.response.data.message}`,
                icon: 'error',
              })
            }
          })
      }
    })
  }

  const handleResendToSAP = async (data: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (accept) => {
      if (accept) {
        await resendToSAP(data.id, {
          due_date: data.due_date,
          credentials: localStorage.getItem('credential'),
          lang: lang,
        })
          .then((res) => {
            swal({
              title: `${t('Already Sent to SAP')}`,
              icon: 'success',
            }).then(async () => {
              setLoading(true)

              const token = localStorage.getItem('token') as string
              const credentials = localStorage.getItem('credential') as string
              const endpoint = `1&credentials=${credentials}&${objToParams(filter)}`
              const res = await axios.get(endpoint, {
                headers: {...headers, Authorization: `Bearer ${token}`},
              })

              setInvoiceData(res.data.data.data)
              setLoading(false)
              setNumberURL(res.data.data.links)
            })
          })
          .catch((err: any) => {
            swal({
              title: `${t(err.response.data.message)}`,
              icon: 'error',
            })
          })
          .finally(() => setLoading(false))
      }
    })
  }

  const handleReloadTable = () => {
    dispatch(resetFilter())
    onFetchInvoice()
  }

  useEffect(() => {
    const fetcher = setTimeout(onFetchInvoice, 1000)
    return () => clearTimeout(fetcher)
  }, [onFetchInvoice])

  useEffect(() => {
    return () => {
      handleReloadTable()
    }
  }, [])

  return (
    <StyledCard>
      <ButtonGroups onSync={syncInvoice} />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>{t('Invoice Number')}</th>
              <th>{t('Invoice Number SAP')}</th>
              <th>{t('kontrak-soNomor')}</th>
              <th>{t('So Number SAP')}</th>
              <th>{t('Customer Code')}</th>
              <th>{t('Customer Name')}</th>
              <th>{t('sub-order-produsen')}</th>
              <th>{t('tanggalInvoice')}</th>
              <th>{t('Jatuh Tempo')}</th>
              <th>Incoterm</th>
              <th>{t('mataUang')}</th>
              <th>TOP</th>
              <th>{t('Total Kuantum')}</th>
              <th>{t('Total Price')}</th>
              <th>Status</th>
              <th>{t('order-aksi')}</th>
            </tr>
          </TableUI.THead>

          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isFailed ? (
              <RowErrorFetch />
            ) : invoiceData.length === 0 ? (
              <RowEmptyData />
            ) : (
              invoiceData?.map((item, _index) => (
                <Fragment key={_index}>
                  <tr>
                    <td>
                      <div style={{display: 'flex', flexDirection: 'row', gap: '1rem'}}>
                        <button
                          className='iconArow d-flex justify-content-start align-items-center'
                          data-target={'target' + item['id']}
                          title={t(tooltip)}
                          onClick={handleOpen}
                        />
                        <span>{item.invoice_number_sap}</span>
                      </div>
                    </td>
                    <td>{item.invoice_number}</td>
                    <td>{item.so_number}</td>
                    <td>{item.so_number_sap}</td>
                    <td>{item.customer_code}</td>
                    <td>
                      <PopoverText
                        content={item.customer_name ? item.customer_name : '-'}
                        index={_index}
                        className='spec-sliceee'
                      />
                    </td>
                    <td>
                      <PopoverText
                        content={item?.sales_org?.name ? item?.sales_org?.name : '-'}
                        index={_index}
                        className='spec-sliceee'
                      />
                    </td>
                    <td>{dateformat(item?.invoice_date)}</td>
                    <td>{dateformat(item?.due_date)}</td>
                    <td>{item.incoterm}</td>
                    <td>{item.currency}</td>
                    <td>
                      <PopoverText
                        content={condTOP(item.top)}
                        index={_index}
                        className='spec-sliceee'
                      />
                    </td>
                    <td>
                      {lang === 'en'
                        ? parseFloat(item?.total_quantum).toLocaleString('en', {
                            maximumFractionDigits: 4,
                          })
                        : parseFloat(item?.total_quantum).toLocaleString('id', {
                            maximumFractionDigits: 4,
                          })}{' '}
                      Ton
                    </td>
                    <td>
                      {item.currency == 'IDR' ? 'Rp' : 'USD'}
                      {lang === 'en'
                        ? parseFloat(item.total_price).toLocaleString('en', {
                            maximumFractionDigits: 4,
                          })
                        : parseFloat(item.total_price).toLocaleString('id', {
                            maximumFractionDigits: 4,
                          })}
                    </td>
                    <td>
                      {item['status'] == '0' ? (
                        <span className='badge badge-light-success'>{t(item.status_text)}</span>
                      ) : item['status'] == '1' ? (
                        <span className='badge badge-light-primary'>{t(item.status_text)}</span>
                      ) : item['status'] == '2' ? (
                        <span className='badge badge-light-primary'>{t(item.status_text)}</span>
                      ) : item['status'] == '13' ? (
                        <span className='badge badge-light-danger'>SAP Error</span>
                      ) : (
                        <span className='badge badge-light-danger'>{t(item.status_text)}</span>
                      )}
                    </td>
                    <td>
                      <div className='d-flex justify-content-center align-items-center'>
                        <button
                          hidden={item.status == 0 ? false : true}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          title={t('Update') + ' Invoice'}
                          onClick={() => handleShowEdit(item)}
                        >
                          <KTSVG
                            path='/media/icons/duotune/pencil-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                        {item.status == '13' && (
                          <button
                            onClick={() => handleResendToSAP(item)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            title={t('sentSAP')}
                          >
                            <i className='fas fa-sync-alt'></i>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>

                  <tr className='fold' id={'target' + item['id']}>
                    <TableUI.TableDetail colSpan={16}>
                      <TableUI.TableWrapper style={{marginBottom: 0}}>
                        <TableUI.Table>
                          <TableUI.THead>
                            <tr style={{backgroundColor: '#274070'}}>
                              <th>{t('Invoice Item Number SAP')}</th>
                              <th>{t('Product Code')}</th>
                              <th>{t('sub-order-produk')}</th>
                              <th>{t('kontrak-kuantum')}</th>
                              <th>{t('kontrak-harga')}</th>
                            </tr>
                          </TableUI.THead>
                          <TableUI.TBody>
                            {item?.invoice_items?.map((subItem: any, subItemIdx: number) => (
                              <tr key={subItemIdx}>
                                <td>{subItem?.invoice_item_number_sap}</td>
                                <td>{subItem?.material_product?.slice(-7)}</td>
                                <td>{subItem?.material_product_desc}</td>
                                <td>
                                  {lang === 'en'
                                    ? parseFloat(subItem?.quantum).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : parseFloat(subItem?.quantum).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}{' '}
                                  Ton
                                </td>
                                <td>
                                  {item.currency == 'IDR' ? 'Rp' : 'USD'}
                                  {lang === 'en'
                                    ? parseFloat(subItem?.price).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : parseFloat(subItem?.price).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}
                                </td>
                              </tr>
                            ))}
                          </TableUI.TBody>
                        </TableUI.Table>
                      </TableUI.TableWrapper>
                    </TableUI.TableDetail>
                  </tr>
                </Fragment>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        centered
        backdrop='static'
        size='lg'
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Konfirmasi Penerimaan Invoice')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md='6'>
              <Row className='mb-4'>
                <Col md={5}>
                  <p className='mt-3 fs-6'>{t('Invoice Number')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control type='text' disabled value={tempDetail.invoice_number} size='sm' />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={5}>
                  <p className='mt-3 fs-6'>{t('tanggalInvoice')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control type='text' disabled value={tempDetail.invoice_date} size='sm' />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={5}>
                  <p className='mt-3 fs-6'>{t('kontrak-soNomor')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control type='text' disabled value={tempDetail.so_number} size='sm' />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={5}>
                  <p className='mt-3 fs-6'>{t('Total Harga')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type='text'
                    disabled
                    value={
                      lang === 'en'
                        ? parseFloat(tempDetail.total_price)?.toLocaleString('en', {
                            maximumFractionDigits: 4,
                          })
                        : parseFloat(tempDetail.total_price)?.toLocaleString('id', {
                            maximumFractionDigits: 4,
                          })
                    }
                    size='sm'
                  />
                </Col>
              </Row>
            </Col>
            <Col md='6'>
              <Row className='mb-4'>
                <Col md={5}>
                  <p className='mt-3 fs-6 opacity-0'></p>
                </Col>
                <Col md={7}>
                  <Form.Control className='opacity-0' type='text' disabled size='sm' />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={5}>
                  <p className='mt-3 fs-6'>{t('Tanggal Terima')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type='date'
                    onChange={(e: any) => setDueDate(e.target.value)}
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={5}>
                  <p className='mt-3 fs-6 opacity-0'></p>
                </Col>
                <Col md={7}>
                  <Form.Control className='opacity-0' type='text' disabled size='sm' />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6 opacity-0'></p>
                </Col>
                <Col md={8}>
                  <Form.Control className='opacity-0' type='text' disabled size='sm' />
                </Col>
              </Row>
            </Col>
          </Row>
          <div className='d-flex justify-content-end'>
            <Button
              variant='primary'
              className='mt-3 mb-3'
              onClick={() => sendEditInvoice(tempDetail.id)}
            >
              {t('order-kirim')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {InvoiceTable}
